import React, { FC } from 'react';
import {
  BlockItemDesktop,
  BlockItemFormat,
} from '../../Items/desktop/BlockItem';
import { BlockItemMobile } from '../../Items/mobile/BlockItem';
import { BlockItemType } from '../../Items/utils';
import { Resource } from '../../utils/useGetBlockItems';

interface BlockItemProps {
  blockItem: BlockItemType;
  isMobile: boolean;
  onAddArticle: (
    sectionId: string,
    blockType: string,
    articleData: BlockItemType,
  ) => void;
  resource?: Resource;
  sectionsIds: string[];
}

export const BlockItem: FC<BlockItemProps> = ({
  blockItem,
  isMobile,
  onAddArticle,
  resource,
  sectionsIds,
}) => {
  const item = {
    ...blockItem,
    blockType: resource?.label,
  };

  if (isMobile) {
    return (
      <BlockItemMobile
        format={BlockItemFormat.CONDENSED}
        item={item}
        sectionsIds={sectionsIds}
        onAddArticle={onAddArticle}
      />
    );
  }

  return <BlockItemDesktop format={BlockItemFormat.CONDENSED} item={item} />;
};
